import { render, staticRenderFns } from "./SenmonCareDiv.vue?vue&type=template&id=68dd920f&"
import script from "./SenmonCareDiv.vue?vue&type=script&lang=ts&"
export * from "./SenmonCareDiv.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports